import React, { Fragment } from 'react'
import Img1 from "../../images/purchase-order.png"
import Img2 from "../../images/review.png"
import Img3 from "../../images/delivered.png"
import Img4 from "../../images/privacy.png"
import Img5 from "../../images/refund.png"
import Img6 from "../../images/commission.png"
import Img7 from "../../images/success.png"
import Img8 from "../../images/delete.png"


const TopBarValues = ({
    orderedCount,
    reviewedCount,
    onHoldCount,
    deliveredCount,
    refundedCount,
    commissionedCount,
    completedCount,
    cancelledCount,
    reviewDeletedCount,
}) => {




    return (
        <Fragment>
            <div className="flex justify-center gap-[1vmax] lg:gap-[2vmax] mb-[1vmax] flex-wrap hidden">
                <div className="w-[48%] lg:w-[18%] flex bg-white p-[1vmax] shadow-1 rounded-lg">
                    <div className="w-[65%] flex justify-between flex-col gap-[1vmax]">
                        <span className="text-[2vmax] font-3 font-[700] text-gray-600" >{orderedCount || 0}</span>
                        <span className="text-gray-600  uppercase text-[1vmax]" >Ordered</span>
                    </div>
                    <div className="w-[35%] flex justify-end items-center">
                        <div className="w-[2.5vmax] h-[2.5vmax] bg-green-500 rounded-full grid 
                        place-items-center">
                            <img src={Img1} alt="" className='w-[1.8vmax] filter invert brightness-0' />

                        </div>
                    </div>
                </div>
                <div className="w-[48%] lg:w-[18%] flex bg-white p-[1vmax] shadow-1 rounded-lg justify-between">
                    <div className="w-[65%] flex justify-between flex-col gap-[1vmax]">
                        <span className="text-[2vmax] font-3 font-[700] text-gray-600" >&nbsp;
                            {reviewedCount || 0}
                        </span>
                        <span className="text-gray-600  uppercase text-[1vmax]" >Reviewed </span>
                    </div>
                    <div className="w-[20%] flex justify-end items-center">
                        <div className="w-[2.5vmax] h-[2.5vmax] bg-pink-500 rounded-full grid place-items-center">
                            <img src={Img2} alt="" className='w-[1.8vmax] filter invert brightness-0' />
                        </div>
                    </div>
                </div>
                <div className="w-[48%] lg:w-[18%] flex bg-white p-[1vmax] shadow-1 rounded-lg">
                    <div className="w-[65%] flex justify-between flex-col gap-[1vmax]">
                        <span className="text-[2vmax] font-3 font-[700] text-gray-600" >
                            {deliveredCount || 0}</span>
                        <span className="text-gray-600 uppercase text-[1vmax]" >Delivered </span>
                    </div>
                    <div className="w-[35%] flex justify-end items-center">
                        <div className="w-[2.5vmax] h-[2.5vmax] bg-orange-400 rounded-full grid place-items-center">
                            <img src={Img3} alt="" className='w-[1.8vmax] filter invert brightness-0' />
                        </div>
                    </div>
                </div>
                <div className="w-[48%] lg:w-[18%] flex bg-white p-[1vmax] shadow-1 rounded-lg">
                    <div className="w-[65%] flex justify-between flex-col gap-[1vmax]">
                        <span className="text-[2vmax] font-3 font-[700] text-gray-600" >
                            {onHoldCount || 0}</span>
                        <span className="text-gray-600 uppercase text-[1vmax]" >ON HOLD </span>
                    </div>
                    <div className="w-[35%] flex justify-end items-center">
                        <div className="w-[2.5vmax] h-[2.5vmax] bg-blue-400 rounded-full grid place-items-center">
                            <img src={Img4} alt="" className='w-[1.8vmax] filter invert brightness-0' />
                        </div>
                    </div>
                </div>
                <div className="w-[48%] lg:w-[18%] flex bg-white p-[1vmax] shadow-1 rounded-lg">
                    <div className="w-[65%] flex justify-between flex-col gap-[1vmax]">
                        <span className="text-[2vmax] font-3 font-[700] text-gray-600" >{refundedCount?.activeCount || 0}</span>
                        <span className="text-gray-600  uppercase text-[1vmax]" >REFUNDED</span>
                    </div>
                    <div className="w-[35%] flex justify-end items-center">
                        <div className="w-[2.5vmax] h-[2.5vmax] bg-green-500 rounded-full grid place-items-center">
                            <img src={Img5} alt="" className='w-[1.5vmax] filter invert brightness-0' />

                        </div>
                    </div>
                </div>
                <div className="w-[48%] lg:w-[18%] flex bg-white p-[1vmax] shadow-1 rounded-lg justify-between">
                    <div className="w-[65%] flex justify-between flex-col gap-[1vmax]">
                        <span className="text-[2vmax] font-3 font-[700] text-gray-600" >&nbsp;
                            {commissionedCount || 0}
                        </span>
                        <span className="text-gray-600  uppercase text-[1vmax]" >COMMISSIONED </span>
                    </div>
                    <div className="w-[20%] flex justify-end items-center">
                        <div className="w-[2.5vmax] h-[2.5vmax] bg-slate-500 rounded-full grid place-items-center">
                            <img src={Img6} alt="" className='w-[1.8vmax] filter invert brightness-0' />
                        </div>
                    </div>
                </div>
                <div className="w-[48%] lg:w-[18%] flex bg-white p-[1vmax] shadow-1 rounded-lg">
                    <div className="w-[65%] flex justify-between flex-col gap-[1vmax]">
                        <span className="text-[2vmax] font-3 font-[700] text-gray-600" >
                            {completedCount || 0}</span>
                        <span className="text-gray-600 uppercase text-[1vmax]" >COMPLETED </span>
                    </div>
                    <div className="w-[35%] flex justify-end items-center">
                        <div className="w-[2.5vmax] h-[2.5vmax] bg-purple-500 rounded-full grid place-items-center">
                            <img src={Img7} alt="" className='w-[1.8vmax] filter invert brightness-0' />
                        </div>
                    </div>
                </div>
                <div className="w-[48%] lg:w-[18%] flex bg-white p-[1vmax] shadow-1 rounded-lg">
                    <div className="w-[65%] flex justify-between flex-col gap-[1vmax]">
                        <span className="text-[2vmax] font-3 font-[700] text-gray-600" >
                            {cancelledCount || 0}</span>
                        <span className="text-gray-600 uppercase text-[1vmax]" >CANCELLED </span>
                    </div>
                    <div className="w-[35%] flex justify-end items-center">
                        <div className="w-[2.5vmax] h-[2.5vmax] bg-[#b04926] rounded-full grid place-items-center">
                            <i className="fa-solid fa-xmark text-white text-[1.5vmax]"></i>

                        </div>
                    </div>
                </div>
                <div className="w-[48%] lg:w-[18%] flex bg-white p-[1vmax] shadow-1 rounded-lg">
                    <div className="w-[65%] flex justify-between flex-col gap-[1vmax]">
                        <span className="text-[2vmax] font-3 font-[700] text-gray-600" >
                            {reviewDeletedCount || 0}</span>
                        <span className="text-gray-600 uppercase text-[1vmax]" >REVIEW DELETED </span>
                    </div>
                    <div className="w-[35%] flex justify-end items-center">
                        <div className="w-[2.5vmax] h-[2.5vmax] bg-red-500 rounded-full grid place-items-center">
                            <img src={Img8} alt="" className='w-[1.8vmax] filter invert brightness-0' />
                        </div>
                    </div>
                </div>
            </div>
        </Fragment>
    )
}

export default TopBarValues